export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40da39f005d9677b1292e51c1eebf872ea37db577e&name=revalidateCommunity!'